import React from 'react';
import styled from 'styled-components';
import { SettlementsNode } from '../graphQL/types';

import { ICON_CLOSE, ICON_NOTICE_BLUE } from 'assets/icons';
import Text from 'components/common/Text';
import HackleManager from 'utils/hackle';
import { formatInvoiceStatus } from 'utils/hackle/parameterFormatting';
import ModalContainer from 'containers/ProductRegist/components/common/ModalContainer';
import CommonImage from 'components/common/CommonImage';
import Column from 'components/common/Column';
import Row from 'components/common/Row';

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 20px 20px 16px 20px;
  width: 100%;
`;

const SettlementContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  width: 100%;
`;

const InformationBadge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 8px;

  border-radius: 8px;
  background: #f4f4f5;
`;

interface SettlementRequestModalIProps {
  isMobile: boolean;
  settlementItem: SettlementsNode;
  type: string;
  handleRequestInvoice?: (id: string) => void;
  onClose: () => void;
}

const SettlementRequestModal: React.FC<
  SettlementRequestModalIProps
> = props => {
  const { isMobile, settlementItem, type, handleRequestInvoice, onClose } =
    props;

  const isMinusSettlement =
    Number(settlementItem.totalPayment.value) +
      Number(settlementItem.totalFee.value) <
    0;

  return (
    <ModalContainer
      isMobile={isMobile}
      isAbled={true}
      onCloseText=" "
      onClose={onClose}
      isBottomSheet={type === 'information'}
      onAcceptText={type === 'request' ? '네, 요청할게요' : '확인'}
      onClick={() => {
        if (type === 'request') {
          HackleManager.logSettlementListPayoutRequestClick(
            settlementItem.id,
            settlementItem.title,
            formatInvoiceStatus(settlementItem.invoice?.status),
            Number(settlementItem.totalFee.value) +
              Number(settlementItem.totalPayment.value),
            Number(settlementItem.totalFee.value),
            Number(settlementItem.totalPayment.value),
          );

          handleRequestInvoice && handleRequestInvoice(settlementItem.id);
          onClose();

          return;
        }

        onClose();
      }}
      style={
        type === 'information'
          ? { gap: '0px', paddingBottom: '40px' }
          : { gap: '0px' }
      }
      buttonStyle={{ padding: '12px 24px' }}
    >
      <Header>
        <CommonImage
          src={ICON_CLOSE}
          onClick={onClose}
          style={{ position: 'absolute', left: '20px' }}
        />
        <Text color="#1b1c1e" size="16px" weight={600}>
          {type === 'request' ? '정산 지급을 요청할까요?' : '정산 미리보기'}
        </Text>
      </Header>
      <SettlementContainer>
        <InformationBadge style={{ width: '105px' }}>
          <Text color="#1b1c1e" size="12px">
            {settlementItem.title.slice(2, 15)}
          </Text>
        </InformationBadge>
        <Column gap="12px">
          <Row justifyContent="space-between" style={{ width: '100%' }}>
            <Text color="#46474C" size="14px">
              수입
            </Text>
            <Text
              color={isMinusSettlement ? '#ff4242' : '#70737C'}
              size="16px"
              weight={400}
            >
              {(
                Number(settlementItem.totalPayment.value) +
                Number(settlementItem.totalFee.value)
              ).toLocaleString()}
              원
            </Text>
          </Row>
          <Row justifyContent="space-between" style={{ width: '100%' }}>
            <Text color="#46474C" size="14px">
              플랫폼 수수료
            </Text>
            <Text
              color={isMinusSettlement ? '#ff4242' : '#70737C'}
              size="16px"
              weight={400}
            >
              {Number(settlementItem.totalFee.value).toLocaleString()}원
            </Text>
          </Row>
        </Column>
        <Row justifyContent="space-between" style={{ width: '100%' }}>
          <Text color="#1b1c1e" size="16px" weight={600}>
            지급 예정 금액
          </Text>
          <Text
            color={isMinusSettlement ? '#FF4242' : '#1b1c1e'}
            size="16px"
            weight={600}
          >
            {Number(settlementItem.totalPayment.value).toLocaleString()}원
          </Text>
        </Row>
        {type === 'request' && (
          <InformationBadge style={{ padding: '14px 12px' }}>
            <Row
              gap="6px"
              justifyContent="flex-start"
              style={{ width: '100%' }}
            >
              <CommonImage
                src={ICON_NOTICE_BLUE}
                onClick={() => {}}
                style={{ width: '16px' }}
              />
              <Text color="#46474C" size="13px">
                {/* 요청 시 일반적으로 가까운 수요일 날짜에 정산금이 지급됩니다. */}
                요청 시 일반적으로 가까운 목요일 날짜에 정산금이
                지급됩니다.(공휴일에는 다음 영업일에 진행)
              </Text>
            </Row>
          </InformationBadge>
        )}
      </SettlementContainer>
    </ModalContainer>
  );
};

export default SettlementRequestModal;
